export var convertToUpdateReportCommand = function (reportId, data) { return ({
    reportInfoId: reportId || undefined,
    reportConstruction: {
        constructionHeaderId: data.construction || null,
        square: Number(data.area) || null,
        firstPlacementRoom: {
            name: data.firstPlacementRoom || null,
        },
        secondPlacementRoom: {
            name: data.secondPlacementRoom || null,
        },
        constructionName: data.name || null,
        constructionType: data.constructionType || null,
    },
}); };
